import { Page } from '@/core/architecture'

import { HtmlFormRelayTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * HtmlFormRelay Page
 *
 * ネイティブアプリがポストの本文にformタグを使われた場合に外部ブラウザでsubmit処理を発火させるための画面
 *
 * ネイティブアプリでは特定のドメインでないとPOST処理が行えず、かつドメインを許容するにはネイティブアプリのビルド・審査が必要になる。
 * かつ、遷移先の画面の処理が複雑な場合、アプリ内ブラウザでは挙動の保証ができないため、外部ブラウザで処理を行う。
 * ただし、ネイティブアプリから外部ブラウザにはPOSTでのアクセスができないため、POST = submit処理を自動で行うための画面が必要。
 */
export const HtmlFormRelay: Page = () => {
  const { state, actions } = useViewModel()

  return <HtmlFormRelayTemplate state={state} actions={actions} />
}
